import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectVehicles } from "./selectVehicles.js";
const selectVehiclesCount = createAppSelector(selectVehicles, (vehicles) => {
  var _a;
  return (_a = vehicles.data) == null ? void 0 : _a.total;
});
export {
  selectVehiclesCount
};
